import logger from '3-foundation/Logging/logger';

import { mapFirstImage } from '../DataTypes/imageMapper';
import { mapFirstLink, mapLinks } from '../DataTypes/linkMapper';
import { mapFooterCardList, Props as FooterCardListProps } from '../PageFooter/footercardListMapper';

export interface Props {
	content: {
		properties: {
			socialLinkType: 'Facebook' | 'Twitter' | 'LinkedIn' | 'Instagram' | 'YouTube';
			socialLinkUrl: Umbraco.Link[];
		};
	};
}

export const mapFooterContent = ({
	image,
	imageAltText,
	footerCardLists,
	socialLinkItems,
	bottomLinkItems,
}: {
	image: Umbraco.Image[];
	imageAltText: string;
	footerCardLists: { properties: { cards: FooterCardListProps } }[];
	socialLinkItems: Props[];
	bottomLinkItems: Umbraco.Link[];
}): Content.FooterContent => {
	try {
		return {
			image: mapFirstImage(image),
			imageAltText: imageAltText,
			cardLists: footerCardLists.map((list) => mapFooterCardList(list?.properties?.cards)),
			socialLinks: socialLinkItems.map((item) => ({
				type: item.content.properties.socialLinkType,
				url: mapFirstLink(item.content.properties.socialLinkUrl),
			})),
			bottomLinks: mapLinks(bottomLinkItems) ?? [],
		};
	} catch (e) {
		logger.error(`Could not map FooterContent \nCause: ${e}`);
		throw new Error(`Could not map FooterContent \nCause: ${e}`, e);
	}
};
